import { useQueries } from '@tanstack/react-query';
import { apiGetProjectPhaseByProjectAndId } from '../../../../../projects/api';
import { ProjectPhase } from '../../../../../../models/ProjectPhase';

interface ProjectPhaseQuery {
  projectId: string;
  projectPhaseId: string;
}

export function useProjectPhases(queries: ProjectPhaseQuery[]) {
  const results = useQueries({
    queries: queries.map(({ projectId, projectPhaseId }) => ({
      queryKey: ['projectPhase', projectId, projectPhaseId],
      queryFn: async () => {
        if (!projectId || !projectPhaseId) return null;
        const result = await apiGetProjectPhaseByProjectAndId(
          projectId,
          projectPhaseId
        );
        return result.data;
      },
      enabled: !!projectId && !!projectPhaseId,
    })),
  });

  const projectPhases = results
    .map((result) => result.data)
    .filter(Boolean) as ProjectPhase[];

  const isLoading = results.some((result) => result.isLoading);
  const isError = results.some((result) => result.isError);

  return {
    data: projectPhases,
    isLoading,
    isError,
  };
}
